import { produce } from 'immer';

import { ChangePageIdCampaignPlaceEditor } from '../../actions/campaignPlaceEditor/changePageIdCampaignPlaceEditor';
import { CampaignPlaceEditorState } from '../../typings/campaignPlaceEditor';

export function changePageIdCampaignPlaceEditor(
    state: CampaignPlaceEditorState,
    action: ChangePageIdCampaignPlaceEditor
): CampaignPlaceEditorState {
    return produce(state, draft => {
        const { editorId, pageId } = action;
        const editor = draft[editorId];

        editor.pageId = pageId;
    });
}
